import logo from "Explore/Assets/logo.png";
import grantforwardLgo from "Explore/Assets/grantforward-logo.jpg";
import styles from "./Footer.module.scss";
import { Button, Container } from "@mui/material";
import classNames from "classnames";
import { IconPack } from "Explore/Config/Icons";
import { LinkWrapper } from "Explore/Components";
import { useLocation } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const showProduct = location.pathname === "/explore";
  return (
    <div
      className={styles["footer"]}
      style={{ marginTop: showProduct ? 0 : 16 }}
    >
      {showProduct && (
        <div className={styles["footer__top"]}>
          <Container className={styles["footer__top__container"]}>
            <p className={styles["footer__top--title"]}>
              Wanna discover our team and other products?
            </p>
            <div className={styles["footer__top--btn-group"]}>
              <LinkWrapper
                target="_blank"
                className={styles["footer__top--button--link-wrapper"]}
                link="https://public-profile.academic.online"
                component={
                  <Button
                    className={styles["footer__top--button"]}
                    variant="outlined"
                  >
                    <div className={styles["footer__top--button--logo"]}>
                      <img src={logo} alt="logo" />
                    </div>
                    <div className={styles["footer__top--button--text"]}>
                      <p
                        className={classNames(
                          styles["footer__top--button--text--title"]
                        )}
                      >
                        Public Profile
                      </p>
                      <p
                        className={classNames(
                          styles["footer__top--button--text--subtitle"]
                        )}
                      >
                        Academic Online
                      </p>
                    </div>
                    {IconPack.arrow}
                  </Button>
                }
              />
              <LinkWrapper
                target="_blank"
                className={styles["footer__top--button--link-wrapper"]}
                link="https://www.grantforward.com/"
                component={
                  <Button
                    className={styles["footer__top--button"]}
                    variant="outlined"
                  >
                    <div className={styles["footer__top--button--logo"]}>
                      <img src={grantforwardLgo} alt="logo" />
                    </div>
                    <div className={styles["footer__top--button--text"]}>
                      <p
                        className={classNames(
                          styles["footer__top--button--text--title"]
                        )}
                      >
                        GrantForward
                      </p>
                      <p
                        className={classNames(
                          styles["footer__top--button--text--subtitle"]
                        )}
                      >
                        GrantForward
                      </p>
                    </div>
                    {IconPack.arrow}
                  </Button>
                }
              />
            </div>
          </Container>
        </div>
      )}
      <div className={styles["footer__bottom"]}>
        <Container className={styles["footer__bottom__container"]}>
          <div className={styles["footer__bottom__left"]}>
            <div className={styles["logo"]}>
              <img src={logo} alt="logo" />
            </div>
            <p className={styles["text"]}>About us</p>
            <LinkWrapper
              link="https://public-profile.academic.online"
              component={
                <p className={classNames(styles["text"], styles["highlight"])}>
                  Public Profile
                </p>
              }
            />
            <LinkWrapper
              link="https://www.grantforward.com/"
              component={
                <p className={classNames(styles["text"], styles["highlight"])}>
                  GrantForward
                </p>
              }
            />
          </div>
          <div className={styles["footer__bottom__right"]}>
            <p className={styles["text"]}>Privacy</p>
            <p className={styles["text"]}>Terms</p>
            <p className={styles["text"]}>Help</p>
            <p className={styles["text"]}>Contact us</p>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Footer;
